// ═══════════════════════════════════════════════════════════════════════════
// Configuración de Supabase por entorno — Etapa 3
//
// La llave `anon` es PÚBLICA por diseño: va en el navegador y no otorga
// acceso por sí sola. Todo el aislamiento lo aplica RLS del lado de Postgres
// (migración 0002). La `service_role`, que SÍ salta RLS, jamás entra aquí ni
// en el repositorio.
//
// El entorno se decide por hostname, con la misma lista blanca que el
// indicador de beta: producción es solo lo que está en PROD_HOSTS.
// ═══════════════════════════════════════════════════════════════════════════

const PROD_HOSTS = ["vinicola-total.pages.dev"];

const ENTORNOS = {
  prod: {
    url: "https://emuzgoalzcufklpaumuf.supabase.co",
    anonKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVtdXpnb2FsemN1ZmtscGF1bXVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMjUxOTUsImV4cCI6MjEwMDkwMTE5NX0.DIRbMFJgw-yV7rgzvc7AfZow_2kazUNybxU5D4U6Gzg",
  },
  dev: {
    url: "https://qpzclreowctwksdweisb.supabase.co",
    anonKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFwemNscmVvd2N0d2tzZHdlaXNiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMjU2NzUsImV4cCI6MjEwMDkwMTY3NX0.shOfi6YrhwbXJJrBwfAvNoZM_Gz6hA29hN24wS1117Q",
  },
};

export const esProduccion = () =>
  typeof location !== "undefined" && PROD_HOSTS.includes(location.hostname);

export const configSupabase = () => (esProduccion() ? ENTORNOS.prod : ENTORNOS.dev);
export const nombreEntorno = () => (esProduccion() ? "producción" : "pruebas");
